import { H as HPC, C as CR, D as DISABLED, E as EZ } from './types-aae419ee.js';
import './request.constants-deb285e0.js';

const SC = 'sc';

const getProductCtasLabels = ({ labels = {}, }) => {
  const { addToCartLabel, removeFromCartLabel, addToMyProductsLabel, removeFromMyProductsLabel, } = labels;
  return {
    addToCartLabel,
    removeFromCartLabel,
    addToMyProductsLabel,
    removeFromMyProductsLabel,
  };
};

const waitForElementLoad = (el) => new Promise((res) => el.addEventListener('load', res, { once: true }));
const sourcesCache = new Map();
const appendScSources = (el, scriptScUrl, styleScUrl) => {
  return Promise.all([{ scriptScUrl }, { styleScUrl }].map(({ scriptScUrl, styleScUrl }) => {
    const url = scriptScUrl || styleScUrl;
    const isCached = sourcesCache.has(url);
    let childElement = null;
    if (scriptScUrl && !isCached) {
      childElement = document.createElement('script');
      childElement.src = scriptScUrl;
    }
    if (styleScUrl && !isCached) {
      childElement = document.createElement('link');
      childElement.rel = 'stylesheet';
      childElement.type = 'text/css';
      childElement.href = styleScUrl;
    }
    if (!isCached && childElement) {
      el.appendChild(childElement);
      const loadPromise = waitForElementLoad(childElement);
      sourcesCache.set(url, loadPromise);
      return loadPromise;
    }
    return sourcesCache.get(url);
  }));
};
class Selector$2 {
  constructor() {
    this.inited = false;
  }
  async init(config) {
    if (!this.inited) {
      await appendScSources(document.body, config.scConfiguratorUrlJS, config.scConfiguratorUrlCSS);
      this.inited = true;
    }
    return this;
  }
  open(config) {
    var _a, _b, _c;
    if (this.inited) {
      if (this.widget) {
        this.widget.destroy();
      }
      let startWidget;
      const functionalIds = config.scFunctionalIds && JSON.parse(config.scFunctionalIds);
      if (!functionalIds) {
        startWidget = (_a = window === null || window === void 0 ? void 0 : window.seWidgetWrapper) === null || _a === void 0 ? void 0 : _a.startHierarchy;
      }
      else {
        startWidget = Array.isArray(functionalIds)
          ? (_b = window.seWidgetWrapper) === null || _b === void 0 ? void 0 : _b.loadConfigModelByFunctionalIds
          : (_c = window.seWidgetWrapper) === null || _c === void 0 ? void 0 : _c.startWidget;
      }
      this.widget = startWidget(functionalIds || config.scDataset, config.scLanguage, config.scCountry, config.scProject, config.scToken, config.scOptions);
      this.widget.addSaveConfigurationListener((rest) => {
        document.dispatchEvent(new CustomEvent('scSelectorAddToCart', { detail: rest }));
      });
    }
    else {
      console.error("Can't open widget, selector is not inited");
    }
    return this;
  }
}
const ScProductSelector = new Selector$2();

class Selector$1 {
  constructor() {
    this.inited = false;
  }
  async init(config) {
    if (!this.inited) {
      await appendScSources(document.body, config.scConfiguratorUrlJS, config.scConfiguratorUrlCSS);
      this.inited = true;
    }
    return this;
  }
  open(config) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    if (this.inited) {
      if (this.widget) {
        this.widget.destroy();
      }
      let dataset;
      if (config.type === HPC) {
        dataset = {
          type: config.type,
          value: {
            product_cr: config.productCR,
          },
        };
      }
      if (config.type === CR) {
        dataset = {
          type: config.type,
          value: config.productCR,
        };
      }
      if (config.enableCrossTechAPI || (dataset === null || dataset === void 0 ? void 0 : dataset.type) === HPC) {
        this.widget = window.seWidgetWrapper.startWidget(dataset, (_a = config.language) !== null && _a !== void 0 ? _a : '', (_b = config.country) !== null && _b !== void 0 ? _b : '', (_c = config.project) !== null && _c !== void 0 ? _c : '', (_d = config.token) !== null && _d !== void 0 ? _d : '', config.options || {});
      }
      else {
        this.widget = window.seWidgetWrapper.loadConfigModelByCoreReference(config.productCR, (_e = config.language) !== null && _e !== void 0 ? _e : '', (_f = config.country) !== null && _f !== void 0 ? _f : '', (_g = config.project) !== null && _g !== void 0 ? _g : '', (_h = config.token) !== null && _h !== void 0 ? _h : '', (_j = config.options) !== null && _j !== void 0 ? _j : {});
      }
      this.widget.addSaveConfigurationListener((rest) => {
        document.dispatchEvent(new CustomEvent('scSelectorAddToCart', { detail: rest }));
      });
    }
    else {
      console.error("Can't open widget, selector is not inited");
    }
    return this;
  }
}
const HpcProductSelector = new Selector$1();

const WINDOW_FEATURES = 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=yes, width=1070, height=700';

class Selector {
  async init(_) {
    return this;
  }
  open({ ezProductSelectorUrl }, isWindowFeaturesDisable = false) {
    if (isWindowFeaturesDisable) {
      window.open(ezProductSelectorUrl, '_blank', '');
    }
    else {
      window.open(ezProductSelectorUrl, '_blank', WINDOW_FEATURES);
    }
    return this;
  }
}
const EzProductSelector = new Selector();

const updateProductCtasSelectorSettings = (data, productCtasButtons) => {
  const isCartCtaAvailable = productCtasButtons === null || productCtasButtons === void 0 ? void 0 : productCtasButtons.cart.isShown;
  const isFavoritesCtaAvailable = productCtasButtons === null || productCtasButtons === void 0 ? void 0 : productCtasButtons.favorites.isShown;
  const isButtonAvailable = isCartCtaAvailable || isFavoritesCtaAvailable;
  const addCartLabel = (productCtasButtons === null || productCtasButtons === void 0 ? void 0 : productCtasButtons.cart.labels.addLabel) || (data && getProductCtasLabels(data).addToCartLabel);
  const addFavoritesLabel = (productCtasButtons === null || productCtasButtons === void 0 ? void 0 : productCtasButtons.favorites.labels.addLabel)
    || (data && getProductCtasLabels(data).addToMyProductsLabel);
  const productCtasLabel = isCartCtaAvailable
    ? addCartLabel
    : isFavoritesCtaAvailable
      ? addFavoritesLabel
      : '';
  return {
    buttons: {
      saveConfiguration: {
        title: productCtasLabel,
        isVisible: isButtonAvailable,
      },
    },
  };
};
const selectorType = {
  configuration: 'configuration',
  productSelector: 'productSelector',
  easySelector: 'easySelector',
  functionModel: 'functionModel',
  semtech: 'semtech',
};
const selectGroupID = (configurationEvent) => {
  if (configurationEvent.type === selectorType.configuration) {
    return configurationEvent.configurationId;
  }
  return '';
};
const formedProductsArr = (productsSC) => {
  const newArr = [];
  productsSC.forEach((item) => {
    const adjustedItem = {
      productId: item.reference,
      quantity: item.quantity || 1,
    };
    if (item.extras) {
      const customizationId = item.extras['custom-configuredReference1'];
      const productCr = item.extras['custom-configuredReference2'];
      if (customizationId) {
        adjustedItem.customizationId = customizationId;
      }
      if (productCr) {
        adjustedItem.productCr = productCr;
      }
    }
    newArr.push(adjustedItem);
  });
  return newArr;
};
const scConfigurationToPostData = (configurationEvent) => {
  const { orderingId, codification, configurationName } = configurationEvent.extras || {};
  return {
    products: formedProductsArr(configurationEvent.products),
    grouping: {
      enable: true,
      displayName: configurationName || '',
      configurationMasterId: selectGroupID(configurationEvent) || '',
      quantity: configurationEvent.quantity || 1,
      backURL: '',
      extras: {
        codification,
        orderingId,
      },
    },
    options: {
      allowPartialAdding: true,
      source: `ps_${configurationEvent.type}`,
    },
  };
};
const switchProductSelector = (config) => {
  switch (config.type) {
    case EZ:
      return EzProductSelector.init(config);
    case SC:
      return ScProductSelector.init(config);
    case HPC:
    case CR:
      return HpcProductSelector.init(config);
    case DISABLED:
    default:
      return Promise.resolve(null);
  }
};

export { switchProductSelector as a, scConfigurationToPostData as s, updateProductCtasSelectorSettings as u };
